/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_IntroInputs */

const en_us2_coaching_intro = /** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train with a personal trainer or follow your students. Training stays each person's own: the group gives the trainer a view of the training and the pen on the plan, and whoever leaves takes everything.`)
};

const pt_br2_coaching_intro = /** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treine com um personal ou acompanhe seus alunos. O treino continua sendo de cada pessoa: a turma dá ao personal a visão do treino e a caneta do plano, e quem sai leva tudo.`)
};

const pt_pt2_coaching_intro = /** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treine com um personal ou acompanhe seus alunos. O treino continua sendo de cada pessoa: a turma dá ao personal a visão do treino e a caneta do plano, e quem sai leva tudo.`)
};

/** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */
const es_419_coaching_intro = en_us2_coaching_intro;

/** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */
const fr_fr2_coaching_intro = en_us2_coaching_intro;

/** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */
const de_de2_coaching_intro = en_us2_coaching_intro;

/** @type {(inputs: Coaching_IntroInputs) => LocalizedString} */
const it_it2_coaching_intro = en_us2_coaching_intro;

/**
* | output |
* | --- |
* | "Train with a personal trainer or follow your students. Training stays each person's own: the group gives the trainer a view of the training and the pen on th..." |
*
* @param {Coaching_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_intro = /** @type {((inputs?: Coaching_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_intro(inputs)
	if (locale === "es-419") return es_419_coaching_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_intro(inputs)
	if (locale === "de-DE") return de_de2_coaching_intro(inputs)
	if (locale === "it-IT") return it_it2_coaching_intro(inputs)
	return en_us2_coaching_intro(inputs)
});
export { coaching_intro as "coaching.intro" }